export default __webpack_public_path__ + "locales/zh-CN/PeopleTranslations.json?hash=29d5e3e5f30a8a0bac292831aaed48da";